import React, { useState, useEffect } from 'react';
import { Container, TextField, Typography, Grid, InputAdornment, Paper, IconButton, Box, Modal, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Button, Chip, Tooltip } from '@mui/material';
import { FormControlLabel, Radio, RadioGroup, FormControl, FormLabel, MenuItem, Select, InputLabel } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

import SearchIcon from '@mui/icons-material/Search';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import SchoolIcon from '@mui/icons-material/School';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


function UpdateRegistration() {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [missingFields, setMissingFields] = useState([]);
  const [showMissingFieldsModal, setShowMissingFieldsModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [enquiryData, setEnquiryData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedEnquiryId, setSelectedEnquiryId] = useState(0); // To store the selected enquiryId
  const [selectedEnquiryDetails, setSelectedEnquiryDetails] = useState({});
  // To store the details of the selected enquiry
  const [gender, setGender] = useState([]);
  const [ddlClass, setDdlClass] = useState([]);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const { registrationId } = useParams();
  const navigate = useNavigate(); // Added navigate hook

  // State for Info Modal
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  useEffect(() => {
  if (selectedEnquiryDetails.countryId) {
    fetchState(selectedEnquiryDetails.countryId);
  }
}, [selectedEnquiryDetails.countryId]);

useEffect(() => {
  if (selectedEnquiryDetails.stateId) {
    fetchCity(selectedEnquiryDetails.stateId);
  }
}, [selectedEnquiryDetails.stateId]);


  useEffect(() => {
    fetchGender();
    fetchddlClass();
    fetchCountry();
  }, []);

  // Fetch gender data
  const fetchGender = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Admission/ddlGender`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching gender: ${response.status}`);
      }
      const data = await response.json();
      setGender(data);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch class data
  const fetchddlClass = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Enquiry/ddlClassName`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching class: ${response.status}`);
      }
      const data = await response.json();
      setDdlClass(data);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch country data
  const fetchCountry = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Registration/ddlCountry`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching country: ${response.status}`);
      }
      const data = await response.json();
      setCountry(data);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch state data
  const fetchState = async (countryId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Registration/ddlState`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          "countryId": countryId
        }),
      });
      if (!response.ok) {
        throw new Error(`Error fetching state: ${response.status}`);
      }
      const data = await response.json();
      if (data && data !== null && data.length > 0) {
        setState(data);
      } else {
        setState([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch city data
  const fetchCity = async (stateId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Registration/ddlCity`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          stateId: stateId
        }),
      });
      if (!response.ok) {
        throw new Error(`Error fetching city: ${response.status}`);
      }
      const data = await response.json();
      if (data && data !== null && data.length > 0) {
        setCity(data);
      } else {
        setCity([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Handle search button click
  const handleSearchClick = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Registration/SearchEnqlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching enquiry list: ${response.status}`);
      }
      const data = await response.json();
      setEnquiryData(data);
      setOpenModal(true);
    } catch (error) {
      console.error(error);
    }
  };

  // Handle select enquiry
  const handleSelect = async (enquiryId) => {
    try {
      const token = sessionStorage.getItem('token');
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/Registration/FetchEnquiryById`;
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({ enquiryId }),
      });
      if (!response.ok) {
        throw new Error(`Error fetching enquiry details: ${response.status}`);
      }
      const data = await response.json();
      setSelectedEnquiryDetails(data[0]); // Assuming only one item is returned in the array
      setOpenModal(false);
    } catch (error) {
      console.error(error);
    }
  };

  // Handle close modal
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // Handle input change
  // const handleInputChange = (event) => {
  //   setSelectedEnquiryDetails({
  //     ...selectedEnquiryDetails,
  //     [event.target.name]: event.target.value
  //   });
  // };

  // Handle save button click
  // Handle input change
  // Handle input change
  // Handle input change
  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === 'dob') {
      const currentDate = new Date();
      const selectedDate = new Date(value);
      const ageDiff = currentDate.getFullYear() - selectedDate.getFullYear();
      const isBeforeBirthday =
        currentDate.getMonth() < selectedDate.getMonth() ||
        (currentDate.getMonth() === selectedDate.getMonth() && currentDate.getDate() < selectedDate.getDate());
      const age = isBeforeBirthday ? ageDiff - 1 : ageDiff;

      setSelectedEnquiryDetails(prev => ({
        ...prev,
        [name]: value,
        age: age,
      }));
    } else {
      setSelectedEnquiryDetails(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };



  useEffect(() => {
    // Fetch state data if countryId is available
    if (selectedEnquiryDetails.countryId) {
      fetchState(selectedEnquiryDetails.countryId);
    }
  }, [selectedEnquiryDetails.countryId]);

  useEffect(() => {
    // Fetch city data if stateId is available
    if (selectedEnquiryDetails.stateId) {
      fetchCity(selectedEnquiryDetails.stateId);
    }
  }, [selectedEnquiryDetails.stateId]);

  const validateForm = () => {
    const mandatoryFields = [
      { name: 'Student Name', value: selectedEnquiryDetails?.name },
      { name: 'Date of Birth', value: selectedEnquiryDetails?.dob },
      { name: 'Contact No.', value: selectedEnquiryDetails?.mobileNo },
      { name: 'Father\'s Name', value: selectedEnquiryDetails?.fatherName },
    ];

    const missing = mandatoryFields.filter(field => !field.value);
    setMissingFields(missing.map(field => field.name));
    return missing.length === 0;
  };



  // Handle save button click
  const handleSave = async () => {
    if (!validateForm()) {
      setShowMissingFieldsModal(true);
      // setMandatoryFieldsError(true);
      return;
    }
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const apiUrl = `${url}/Registration/Id?Id=${registrationId}`;

      const dobParts = selectedEnquiryDetails?.dob?.split('-');
      const formattedDOB = dobParts ? `${dobParts[2]}/${dobParts[1]}/${dobParts[0]}` : selectedEnquiryDetails?.dob || '';

      const payload = {
        registrationNo: selectedEnquiryDetails?.registrationNo || "New",
        dated: new Date().toLocaleDateString('en-GB'),
        enquiryStatus: 0,
        enquiryID: selectedEnquiryId,
        prostetusNo: selectedEnquiryDetails?.prostetusNo || "string",
        regFees: selectedEnquiryDetails?.regFees || 0,
        classID: selectedEnquiryDetails?.classId || 0,
        name: selectedEnquiryDetails?.name || "",
        fatherName: selectedEnquiryDetails?.fatherName || "",
        dob: formattedDOB,
        age: selectedEnquiryDetails?.age || 0,
        gender: selectedEnquiryDetails?.genderId || 0,
        nationality: selectedEnquiryDetails?.nationality || "",
        pinCode: selectedEnquiryDetails?.pinCode || "",
        alternateNo: selectedEnquiryDetails?.alternateMobile || "",
        mobileNo: selectedEnquiryDetails?.mobileNo || "",
        email: selectedEnquiryDetails?.email || "",
        address: selectedEnquiryDetails?.address || "",
        motherName: selectedEnquiryDetails?.motherName || "",
        grandFather: selectedEnquiryDetails?.grandFather || "",
        adharNo: selectedEnquiryDetails?.adharNO || "000000000000",
        countryId: selectedEnquiryDetails?.countryId || 0,
        stateId: selectedEnquiryDetails?.stateId || 0,
        cityID: selectedEnquiryDetails?.cityId || 0
      };

      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Error saving registration: ${response.status}`);
      }

      setShowSuccessModal(true);

    } catch (error) {
      console.error(error);
      // alert('Failed to update registration. Please try again.');
      setSnackbarMessage('Failed to update registration. Please try again.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };


  useEffect(() => {
    const fetchRegistrationDetails = async () => {
      try {
        const token = sessionStorage.getItem('token');
        const url = process.env.REACT_APP_BASE_URL;
        const apiUrl = `${url}/Registration/RegId?Id=${registrationId}`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token,
          },
        });
        if (!response.ok) {
          throw new Error(`Error fetching registration details: ${response.status}`);
        }
        const data = await response.json();
        // Assuming data[0] contains the registration details
        const registrationData = data[0];
        // Format DOB if it's in dd/mm/yyyy format to YYYY-MM-DD for date input
        if (registrationData.dob && registrationData.dob.includes('/')) {
          const [day, month, year] = registrationData.dob.split('/');
          registrationData.dob = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
        setSelectedEnquiryDetails(registrationData);
        // Fetch dependent dropdowns if IDs exist
        if (registrationData.countryId) fetchState(registrationData.countryId);
        if (registrationData.stateId) fetchCity(registrationData.stateId);
      } catch (error) {
        console.error('Error fetching registration details:', error);
      }
    };

    fetchRegistrationDetails();
  }, [registrationId]);

  // Info sections data for the Info Modal
  const infoSections = [
    {
      icon: <EditNoteIcon sx={{ color: "#1976d2", fontSize: 22 }} />,
      title: "Registration Info Fields",
      color: "#e3f2fd",
      borderColor: "#1976d2",
      items: [
        { label: "Reg No.", desc: "Auto-assigned registration number for the record." },
        { label: "Enquiry No.", desc: "Link to an existing enquiry using the search icon. Pre-fills student details automatically." },
        { label: "Date", desc: "The date of registration. Defaults to today's date on save." },
        { label: "Without Enquiry", desc: "Toggle to indicate whether this registration is linked to an enquiry or entered independently." },
      ],
    },
    {
      icon: <SchoolIcon sx={{ color: "#7b1fa2", fontSize: 22 }} />,
      title: "Class Details",
      color: "#f3e5f5",
      borderColor: "#7b1fa2",
      items: [
        { label: "Class", desc: "Select the class the student is applying for. Required field." },
        { label: "DOB", desc: "Student's date of birth. Age is auto-calculated from this field." },
      ],
    },
    {
      icon: <PersonIcon sx={{ color: "#e65100", fontSize: 22 }} />,
      title: "Personal Details",
      color: "#fff3e0",
      borderColor: "#e65100",
      items: [
        { label: "Student Name", desc: "Full name of the student. Mandatory field." },
        { label: "Father's Name", desc: "Father's full name. Mandatory field." },
        { label: "Mother's Name", desc: "Mother's full name." },
        { label: "Grand Father's Name", desc: "Grandfather's full name." },
        { label: "Prospectus", desc: "Prospectus number if applicable." },
        { label: "Aadhar No.", desc: "12-digit Aadhar card number of the student." },
        { label: "Gender", desc: "Select gender from the dropdown." },
        { label: "Nationality", desc: "Student's nationality." },
        { label: "Mobile No.", desc: "Primary contact number (10 digits). Mandatory field." },
        { label: "Alternate Mobile No.", desc: "Secondary contact number (10 digits)." },
        { label: "Email-Id", desc: "Student or guardian's email address." },
        { label: "Address", desc: "Residential address of the student." },
        { label: "Pin Code", desc: "Postal/ZIP code of the student's address." },
      ],
    },
    {
      icon: <ContactPhoneIcon sx={{ color: "#2e7d32", fontSize: 22 }} />,
      title: "Location Fields",
      color: "#e8f5e9",
      borderColor: "#2e7d32",
      items: [
        { label: "Country", desc: "Select the country. Automatically loads the relevant states on selection." },
        { label: "State", desc: "Select the state based on the chosen country. Automatically loads cities." },
        { label: "City", desc: "Select the city based on the chosen state." },
      ],
    },
    {
      icon: <EditNoteIcon sx={{ color: "#ad1457", fontSize: 22 }} />,
      title: "Actions & Validation",
      color: "#fce4ec",
      borderColor: "#ad1457",
      items: [
        { label: "UPDATE", desc: "Saves the updated registration. Validates mandatory fields before submitting." },
        { label: "CANCEL", desc: "Navigates back to the previous page without saving any changes." },
        { label: "Mandatory Fields", desc: "Student Name, Date of Birth, Contact No., and Father's Name are required. Missing fields are shown in a modal." },
        { label: "Enquiry Search", desc: "Click the search icon in the Enquiry No. field to open the enquiry list and auto-fill student details." },
      ],
    },
  ];

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: '#0B1F40', // dark navy blue
          padding: '12px 24px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          width: "100%",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', textAlign: 'center', fontWeight: 'bold' }}>
          Update Registration
        </Typography>

        {/* Info Button */}
        <Box sx={{ position: 'absolute', right: '24px' }}>
          <Tooltip title="View page information & guide" arrow placement="left">
            <IconButton
              onClick={() => setInfoModalOpen(true)}
              size="small"
              sx={{
                color: "rgba(255,255,255,0.75)",
                backgroundColor: "rgba(255,255,255,0.1)",
                border: "1.5px solid rgba(255,255,255,0.25)",
                borderRadius: "50%",
                width: 32,
                height: 32,
                transition: "all 0.2s ease",
                "&:hover": {
                  backgroundColor: "#1976d2",
                  borderColor: "#64B5F6",
                  color: "#ffffff",
                  boxShadow: "0 0 0 3px rgba(100,181,246,0.25)",
                  transform: "scale(1.1)",
                },
              }}
            >
              <InfoOutlinedIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      {/* Registration Details */}
      <form>
        <Paper elevation={3} style={{ padding: '20px', marginTop: 6 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
             <TextField
  fullWidth
  label="Reg No."
  variant="outlined"
  placeholder="Enter Registration No."
  margin="normal"
  value={selectedEnquiryDetails?.registrationNo || ''}
  InputProps={{ readOnly: true }}
/>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Enquiry No."
                variant="outlined"
                placeholder="Enter Enquiry No."
                margin="normal"
                value={selectedEnquiryDetails?.enquiryCode || ''}
                InputProps={{
                  readOnly: true,
                
                  
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
             <TextField
  fullWidth
  label="Date"
  type="date"
  variant="outlined"
  InputLabelProps={{ shrink: true }}
  margin="normal"
  value={
    selectedEnquiryDetails?.registrationDate
      ? selectedEnquiryDetails.registrationDate.split('/').reverse().join('-')
      : ''
  }
  InputProps={{ readOnly: true }}
/>
            </Grid>
            <Grid item xs={12}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Without Enquiry</FormLabel>
                <RadioGroup row aria-label="enquiry" name="enquiry">
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          {/* Class Details */}
          <Typography variant="h6" style={{ marginTop: '20px', marginBottom: '20px' }}>Class Details</Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="class-label">Class *</InputLabel>
                <Select
                  labelId="class-label"
                  id="class"
                  label="Class *"
                  value={selectedEnquiryDetails?.classId || ''}
                  required
                >
                  {ddlClass.map((item) => (
                    <MenuItem key={item.classId} value={item.classId}>{item.className}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="DOB *"
                type="date"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={selectedEnquiryDetails?.dob || ''}
                onChange={handleInputChange}
                name="dob"
                required
              />
            </Grid>
          </Grid>

          {/* Personal Details */}
          <Typography variant="h6" style={{ marginTop: '20px', marginBottom: '20px' }}>Personal Details</Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Student Name *" variant="outlined" value={selectedEnquiryDetails?.name || ''} required onChange={handleInputChange} name="studentName" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Father's Name *" variant="outlined" value={selectedEnquiryDetails?.fatherName || ''} required onChange={handleInputChange} name="fatherName" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Mother's Name *" variant="outlined" value={selectedEnquiryDetails?.motherName || ''} required onChange={handleInputChange} name="motherName" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Grand Father's Name *"
                variant="outlined"
                value={selectedEnquiryDetails?.grandFather || ''}
                required
                onChange={handleInputChange}
                name="grandFather" // Changed to match state property
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Prospectus" variant="outlined" value={selectedEnquiryDetails?.prospectus || ''} onChange={handleInputChange} name="prospectus" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Aadhar No." variant="outlined" value={selectedEnquiryDetails?.adharNO || ''} inputProps={{ maxLength: "12" }} onChange={handleInputChange} name="aadharNo" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel id="gender-label">Gender *</InputLabel>
                <Select
                  labelId="gender-label"
                  id="gender"
                  label="Gender *"
                  required
                  value={selectedEnquiryDetails?.genderId || ''}
                  onChange={handleInputChange}
                  name="gender"
                >
                  {gender.map((item) => (
                    <MenuItem key={item.genderId} value={item.genderId}>{item.gender}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Nationality" variant="outlined" value={selectedEnquiryDetails?.nationality || ''} onChange={handleInputChange} name="nationality" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Mobile No. *" variant="outlined" inputProps={{ maxLength: "10" }} value={selectedEnquiryDetails?.mobileNo || ''} required onChange={handleInputChange} name="mobileNo" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Alternate Mobile No. *" inputProps={{ maxLength: "10" }} variant="outlined" value={selectedEnquiryDetails?.alternateMobile || ''} required onChange={handleInputChange} name="alternateMobile" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Email-Id" variant="outlined" value={selectedEnquiryDetails?.email || ''} onChange={handleInputChange} name="emailId" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Address" variant="outlined" value={selectedEnquiryDetails?.address || ''} onChange={handleInputChange} name="address" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Pin Code" variant="outlined" value={selectedEnquiryDetails?.pincode || ''} onChange={handleInputChange} name="pinCode" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel id="country-label">Country *</InputLabel>
               <Select
  labelId="country-label"
  id="country"
  label="Country *"
  required
  value={selectedEnquiryDetails?.countryId || ""}
  onChange={(event) => {
    handleInputChange(event);
    fetchState(event.target.value);
  }}
  name="countryId"
>
                  {country.map((item) => (
                    <MenuItem key={item.countryId} value={item.countryId}>{item.countryName}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel id="state-label">State *</InputLabel>
               <Select
  labelId="state-label"
  id="state"
  label="State *"
  required
  value={selectedEnquiryDetails?.stateId || ""}
  onChange={(event) => {
    handleInputChange(event);
    fetchCity(event.target.value);
  }}
  name="stateId"
>
                  {state.map((item) => (
                    <MenuItem key={item.stateId} value={item.stateId}>{item.stateName}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel id="city-label">City *</InputLabel>
               <Select
  labelId="city-label"
  id="city"
  label="City *"
  required
  value={selectedEnquiryDetails?.cityId || ""}
  onChange={handleInputChange}
  name="cityId"
>
                  {city.map((item) => (
                    <MenuItem key={item.cityId} value={item.cityId}>{item.cityName}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Buttons */}
          <div style={{ marginTop: '20px', textAlign: 'end' }}>
            <Button variant="contained" color="primary" style={{
              marginRight: '10px', width: "100px",
              height: "50px",
              padding: "10px 0",
              fontWeight: 'bold'
            }} onClick={handleSave}>UPDATE</Button>
            <Button variant="contained" color="error" onClick={() => { navigate(-1) }} style={{
              width: "100px",
              height: "50px",
              padding: "10px 0",
              fontWeight: 'bold'
            }}>CANCEL</Button>
          </div>
        </Paper>
      </form>
      {/* Modal */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="enquiry-list-modal"
        aria-describedby="enquiry-list-modal-description"
      >
        <Container sx={{ marginTop: '20px', width: '80vw', height: '80vh', backgroundColor: 'white', borderRadius: '8px', padding: '20px' }}>
          <Typography variant="h5" align="center" gutterBottom>
            Enquiry List
          </Typography>
          <TableContainer sx={{ maxHeight: '60vh' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Enquiry ID</TableCell>
                  <TableCell>Student Name</TableCell>
                  <TableCell>Enquiry Code</TableCell>
                  <TableCell>Parent/Guardian</TableCell>
                  <TableCell>Contact No.</TableCell>
                  <TableCell>Enquiry Date</TableCell>
                  <TableCell>Class Name</TableCell>
                  <TableCell>Select</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {enquiryData.map((enquiry) => (
                  <TableRow key={enquiry.enquiryId}>
                    <TableCell>{enquiry.enquiryId}</TableCell>
                    <TableCell>{enquiry.studentName}</TableCell>
                    <TableCell>{enquiry.enquiryCode}</TableCell>
                    <TableCell>{enquiry.parentAndGurdian}</TableCell>
                    <TableCell>{enquiry.contactNo}</TableCell>
                    <TableCell>{enquiry.enquiryDate}</TableCell>
                    <TableCell>{enquiry.className}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          setSelectedEnquiryId(enquiry.enquiryId);
                          handleSelect(enquiry.enquiryId);
                        }}
                      >
                        Select
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Container>
      </Modal>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Registration Updated ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Registration has been Updated successfully.
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={showMissingFieldsModal}
        onClose={() => setShowMissingFieldsModal(false)}
        aria-labelledby="missing-fields-modal-title"
        aria-describedby="missing-fields-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="missing-fields-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Missing Fields
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="missing-fields-modal-description" sx={{ mb: 2 }}>
              The following fields are required:
            </Typography>
            <ul>
              {missingFields.map((field, index) => (
                <li key={index}>- {field}</li>
              ))}
            </ul>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => setShowMissingFieldsModal(false)}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Info Modal */}
      <Modal
        open={infoModalOpen}
        onClose={() => setInfoModalOpen(false)}
        aria-labelledby="info-modal-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95vw", sm: 620, md: 680 },
            maxHeight: "85vh",
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: "0 24px 64px rgba(11,31,61,0.22)",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Info Modal Header */}
          <Box
            sx={{
              background: "linear-gradient(135deg, #0B1F40 0%, #1565C0 100%)",
              padding: "16px 20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexShrink: 0,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  backgroundColor: "rgba(255,255,255,0.15)",
                  borderRadius: "50%",
                  width: 36,
                  height: 36,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <InfoOutlinedIcon sx={{ color: "#fff", fontSize: 20 }} />
              </Box>
              <Box>
                <Typography id="info-modal-title" variant="h6" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.2 }}>
                  Update Registration — Guide
                </Typography>
                <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.65)" }}>
                  Complete reference for all fields and actions
                </Typography>
              </Box>
            </Box>
            
          </Box>

          {/* Info Modal Scrollable Body */}
          <Box sx={{ overflowY: "auto", p: 2.5, display: "flex", flexDirection: "column", gap: 2 }}>

            {/* Page Overview */}
            <Box
              sx={{
                backgroundColor: "#f0f4ff",
                border: "1px solid #c5d3f0",
                borderRadius: 2,
                p: 2,
              }}
            >
              <Typography variant="body2" sx={{ color: "#1a237e", lineHeight: 1.7 }}>
                The <strong>Update Registration</strong> page allows you to modify an existing student registration. You can link it to an enquiry using the search icon to auto-fill details, or edit all fields manually before saving.
              </Typography>
            </Box>

            {/* Sections */}
            {infoSections.map((section, sIdx) => (
              <Box
                key={sIdx}
                sx={{
                  backgroundColor: section.color,
                  border: `1px solid ${section.borderColor}30`,
                  borderLeft: `4px solid ${section.borderColor}`,
                  borderRadius: 2,
                  p: 2,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                  {section.icon}
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#1a1a2e", fontSize: "0.95rem" }}>
                    {section.title}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8 }}>
                  {section.items.map((item, iIdx) => (
                    <Box key={iIdx} sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
                      <Chip
                        label={item.label}
                        size="small"
                        sx={{
                          fontSize: "0.7rem",
                          fontWeight: 600,
                          height: 22,
                          flexShrink: 0,
                          backgroundColor: `${section.borderColor}18`,
                          color: section.borderColor,
                          border: `1px solid ${section.borderColor}40`,
                          mt: "1px",
                        }}
                      />
                      <Typography variant="body2" sx={{ color: "#424242", lineHeight: 1.5, fontSize: "0.82rem" }}>
                        {item.desc}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            ))}

            {/* Tip Box */}
            <Box
              sx={{
                backgroundColor: "#fffde7",
                border: "1px solid #f9a825",
                borderRadius: 2,
                p: 2,
                display: "flex",
                gap: 1.5,
                alignItems: "flex-start",
              }}
            >
              <Typography sx={{ fontSize: "1.1rem", mt: "1px" }}>💡</Typography>
              <Typography variant="body2" sx={{ color: "#5d4037", lineHeight: 1.65, fontSize: "0.82rem" }}>
                <strong>Pro Tip:</strong> Use the <em>search icon</em> in the Enquiry No. field to quickly pull existing enquiry data into the form — this saves time and reduces manual entry errors. Country → State → City dropdowns are cascading and load automatically.
              </Typography>
            </Box>

          </Box>

          {/* Info Modal Footer */}
          <Box
            sx={{
              borderTop: "1px solid #e0e0e0",
              px: 2.5,
              py: 1.5,
              display: "flex",
              justifyContent: "flex-end",
              flexShrink: 0,
              backgroundColor: "#fafafa",
            }}
          >
            <Button
              onClick={() => setInfoModalOpen(false)}
              variant="contained"
              color="primary"
              sx={{ fontWeight: 600, px: 3 }}
            >
              Got It
            </Button>
          </Box>
        </Box>
      </Modal>

<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

    </Container>
  );
}

export default UpdateRegistration;